import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useVatDeclaration } from '../../../../../../context/vatDeclarationContext'

export const SideActionsPrimaryButton = (): ReactElement => {
  const { t } = useTranslation()
  const { isPeriodSettled: shouldShowRegisterPaymentButton } = useVatDeclaration()

  const { open: openRegisterPaymentModal } = useModal(ModalId.VatDeclarationsRegisterPeriodPaymentModal)
  const { open: openSettlementModal } = useModal(ModalId.VatDeclarationsSettlePeriodModal)

  const handleSettleButtonClick = useCallback(() => {
    openSettlementModal()
  }, [openSettlementModal])

  const handleRegisterPaymentButtonClick = useCallback(() => {
    openRegisterPaymentModal()
  }, [openRegisterPaymentModal])

  return shouldShowRegisterPaymentButton ? (
    <Button onClick={handleRegisterPaymentButtonClick}>{t('vat_declarations.actions.register_payment')}</Button>
  ) : (
    <Button onClick={handleSettleButtonClick}>{t('vat_declarations.actions.settle')}</Button>
  )
}
